import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconDynamicField(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 7C5 7.55229 4.55228 8 4 8C3.44772 8 3 7.55229 3 7V4C3 3.44772 3.44772 3 4 3H7C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H5V7Z"
        fill="currentColor"
      />
      <path
        d="M3 17C3 16.4477 3.44772 16 4 16C4.55228 16 5 16.4477 5 17V19H7C7.55229 19 8 19.4477 8 20C8 20.5523 7.55229 21 7 21H4C3.44772 21 3 20.5523 3 20V17Z"
        fill="currentColor"
      />
      <path
        d="M17 5C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17Z"
        fill="currentColor"
      />
      <path
        d="M19 17C19 16.4477 19.4477 16 20 16C20.5523 16 21 16.4477 21 17V20C21 20.5523 20.5523 21 20 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H19V17Z"
        fill="currentColor"
      />
      <path
        d="M9 8C9 7.44772 9.44772 7 10 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H13V15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H10C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15H11V9H10C9.44772 9 9 8.55228 9 8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
